import React from 'react';
import axios from 'axios';
import FontAwesome from 'react-fontawesome';
import {
    Button, ControlLabel, Form, FormControl, FormGroup, HelpBlock, OverlayTrigger,
    Radio, Tooltip
} from "react-bootstrap";
import {withRouter} from "react-router-dom";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

import Loading from "../../components/Loading/index";
import CollapsiblePanel from "../../components/Accordion/CollapsiblePanel";
import Accordion from "../../components/Accordion/index";

class EducationMaterialForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            inProcess: false,
            loading: this.props.match.params.id ? true : false,
            values: {
                name: '',
                shortText: '',
                materialText: '',
                picture: null,
                enabled: false,
                questions: [
                    {
                        text: '',
                        explanation: '',
                        timeframe: 0,
                        difficulty: 0,
                        pointsValue: 10,
                        moneyValue: 10,
                        answers: [],
                        questionType: ['educationmaterial'],
                        authorId: null,
                        enabled: true,
                    },
                    {
                        text: '',
                        explanation: '',
                        timeframe: 0,
                        difficulty: 0,
                        pointsValue: 10,
                        moneyValue: 10,
                        answers: [],
                        questionType: ['educationmaterial'],
                        authorId: null,
                        enabled: true,
                    },
                    {
                        text: '',
                        explanation: '',
                        timeframe: 0,
                        difficulty: 0,
                        pointsValue: 10,
                        moneyValue: 10,
                        answers: [],
                        questionType: ['educationmaterial'],
                        authorId: null,
                        enabled: true,
                    }
                ],
                answersToDelete: []
            },
            validation: {
                states: {
                    name: null,
                    shortText: null,
                    materialText: null,
                    explanation: null,
                    timeframe: null,
                    pointsValue: null,
                    moneyValue: null,
                    questions: [
                        {
                            text: null,
                            explanation: null,
                            answers: []
                        },
                        {
                            text: null,
                            explanation: null,
                            answers: []
                        },
                        {
                            text: null,
                            explanation: null,
                            answers: []
                        }
                    ],
                    questionMessage: null
                },
                messages: {
                    name: '',
                    shortText: '',
                    materialText: '',
                    explanation: '',
                    timeframe: '',
                    pointsValue: '',
                    moneyValue: '',
                    questions: [
                        {
                            text: '',
                            explanation: '',
                            answers: []
                        },
                        {
                            text: '',
                            explanation: '',
                            answers: []
                        },
                        {
                            text: '',
                            explanation: '',
                            answers: []
                        }
                    ],
                    questionMessage: ''
                }
            }
        };

        // handles
        this.handleChangeName = this.handleChangeName.bind(this);
        this.handleChangeShortText = this.handleChangeShortText.bind(this);
        this.handleChangeText = this.handleChangeText.bind(this);

        // handles for questions
        this.handleChangeQuestionText = this.handleChangeQuestionText.bind(this);

        // handles for answers
        this.handleChangeAnswerText = this.handleChangeAnswerText.bind(this);
        this.handleChangeAnswerCorrectness = this.handleChangeAnswerCorrectness.bind(this);
        this.handleAddAnswer = this.handleAddAnswer.bind(this);
        this.handleRemoveAnswer = this.handleRemoveAnswer.bind(this);

        // handle for form
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleClose = this.handleClose.bind(this);
    }

    componentDidMount() {
        if (this.props.sessionData && this.props.sessionData.accessToken) {
            this.getEducationMaterial();
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.sessionData && nextProps.sessionData.accessToken) {
            this.getEducationMaterial();
        }
    }

    getEducationMaterial() {
        if (this.props.match.params.id) {
            let loginToken = this.props.sessionData.accessToken;
            let config = {
                headers: {
                    'Authorization': 'Bearer ' + loginToken
                }
            };
            axios.get(this.props.api.educationMaterials + "/" + this.props.match.params.id, config)
            .then((response) => {
                if(!this._componentWillUnmount) {
                    this.setState({
                        values: {
                            ...response.data,
                            answersToDelete: []
                        },
                        validation: {
                            states: {
                                ...this.state.validation.states,
                                questions: response.data.questions.map((question) => {
                                    return (
                                        {
                                            text: null,
                                            explanation: null,
                                            answers: question.answers.map(() => {
                                                return (
                                                    {
                                                        text: null,
                                                    }
                                                )
                                            })
                                        }
                                    )
                                })
                            },
                            messages: {
                                ...this.state.validation.messages,
                                questions: response.data.questions.map((question) => {
                                    return (
                                        {
                                            text: '',
                                            explanation: '',
                                            answers: question.answers.map(() => {
                                                return (
                                                    {
                                                        text: ''
                                                    }
                                                )
                                            })
                                        }
                                    )
                                })
                            }
                        },
                        loading: false
                    });
                }
            }).catch((error) => {
                console.log(error);
                this.props.addNotification('error', error.response.status, 'Nepodařilo se načíst vzdělávací materiál!');
                this.props.history.push('/educationMaterials');
                console.log('Axios error: ', error);
            });
        }
    }

    /* Handles */
    handleChangeName(event) {
        let value =  event ? event.target.value : this.state.values.name;

        let values = this.state.values;
        values.name = value;

        let validation = this.state.validation;
        validation.states.name = value === '' ? 'error' : 'success';
        validation.messages.name = value === '' ? 'Název vzdělávacího materiálu nesmí být prázdný!' : '';

        this.setState({
            values,
            validation
        });
    }

    handleChangeShortText(event) {
        let value =  event ? event.target.value : this.state.values.shortText;

        let values = this.state.values;
        values.shortText = value;

        let validation = this.state.validation;
        validation.states.shortText = value === '' ? 'error' : 'success';
        validation.messages.shortText = value === '' ? 'Popis vzdělávacího materiálu nesmí být prázdný!' : '';

        this.setState({
            values,
            validation
        });
    }

    handleChangeText(value) {
        value = value ? value : this.state.values.materialText;
        let values = this.state.values;
        values.materialText = value;

        let validation = this.state.validation;
        validation.states.materialText = value === '' ? 'error' : 'success';
        validation.messages.materialText = value === '' ? 'Obsah vzdělávacího materiálu nesmí být prázdný!' : '';

        this.setState({
            values,
            validation
        });
    }

    /* Handles for questions */
    handleChangeQuestionText(event, questionIndex) {
        let value =  event ? event.target.value : this.state.values.questions[questionIndex].text;

        let values = this.state.values;
        values.questions[questionIndex].text = value;

        let validation = this.state.validation;
        validation.states.questions[questionIndex].text = value === '' ? 'error' : 'success';
        validation.messages.questions[questionIndex].text = value === '' ? 'Znění otázky nesmí být prázdné!' : '';

        this.setState({
            values,
            validation
        });
    }

    handleChangeQuestionExplanation(event, questionIndex) {
        let value =  event ? event.target.value : this.state.values.questions[questionIndex].explanation;

        let values = this.state.values;
        values.questions[questionIndex].explanation = value;

        let validation = this.state.validation;
        validation.states.questions[questionIndex].explanation = value === '' ? 'error' : 'success';
        validation.messages.questions[questionIndex].explanation = value === '' ? 'Vysvětlení otázky nesmí být prázdné!' : '';

        this.setState({
            values,
            validation
        });
    }

    // handles for answers
    handleChangeAnswerText(event, questionIndex, answerIndex) {
        const text =  event ? event.target.value : this.state.values.questions[questionIndex].answers[answerIndex].text;

        let values = this.state.values;
        values.questions[questionIndex].answers[answerIndex].text = text;

        const validation = this.state.validation;
        validation.states.questions[questionIndex].answers[answerIndex].text = text === '' ? 'error' : 'success';
        validation.messages.questions[questionIndex].answers[answerIndex].text = text === '' ? 'Znění odpovědi nesmí být prázdné!' : '';

        this.setState({
            values,
            validation
        });
    }

    handleChangeAnswerCorrectness(event, questionIndex, answerIndex) {
        let correctness = event ? event.target.checked : this.state.values.questions[questionIndex].answers[answerIndex].correctness;

        let values = this.state.values;

        if (event) {
            values.questions[questionIndex].answers.map((answer) => {
                answer.correctness = false;
                return answer;
            });
            values.questions[questionIndex].answers[answerIndex].correctness = correctness;
        }

        this.setState({
            values
        });
    }

    handleAddAnswer(questionIndex) {
        let values = this.state.values;

        const newAnswer = {
            text: '',
            correctness: false,
        };

        values.questions[questionIndex].answers.push(newAnswer);

        let validation = this.state.validation;
        validation.states.questions[questionIndex].answers.push({text: null});
        validation.messages.questions[questionIndex].answers.push({text: ''});

        this.setState({
            values,
            validation
        });

    }

    handleRemoveAnswer(questionIndex, answerIndex) {
        let values = this.state.values;
        let answer = values.questions[questionIndex].answers[answerIndex];

        if (answer._id) values.answersToDelete.push(answer);
        values.questions[questionIndex].answers.splice(answerIndex, 1);

        let validation = this.state.validation;
        validation.states.questions[questionIndex].answers.splice(answerIndex, 1);
        validation.messages.questions[questionIndex].answers.splice(answerIndex, 1);

        this.setState({
            values
        });
    }
    /* /Handles */

    /* Form functions */
    validateQuestions() {
        let valid = true;

        let validation = this.state.validation;
        validation.states.questionMessage = null;
        validation.messages.questionMessage = '';

        // provedení kontrol
        let questions = this.state.values.questions;
        questions.forEach((question, questionIndex) => {
            this.handleChangeQuestionText(null, questionIndex);
            this.handleChangeQuestionExplanation(null, questionIndex);
            let answers = question.answers;
            answers.forEach((answer, answerIndex) => {
                this.handleChangeAnswerText(null, questionIndex, answerIndex);
            });

            // kontrola vybrání správné odpovědi
            if (answers.map((answer) => answer.correctness).indexOf(true) === -1) {
                validation.messages.questionMessage += (questionIndex+1) + '. otázka nemá vybranou správnou odpověď! ';
                validation.states.questionMessage = 'error';
                valid = false;
            }
        });

        let questionStates = this.state.validation.states.questions;
        let answerStates;

        // validace otázek
        questionStates.forEach((question) => {
            if (Object.values(question).indexOf('error') !== -1) {
                valid = false;
                return false;
            } else {
                answerStates = question.answers;
                answerStates.forEach((answer) => {
                   if (Object.values(answer).indexOf('error') !== -1) {
                       valid = false;
                       return false;
                   }
                });
            }
        });

        this.setState({
            validation
        });

        return valid;
    }

    isValid () {
        this.handleChangeName();
        this.handleChangeShortText();
        this.handleChangeText();
        this.validateQuestions();

        let valid = (Object.values(this.state.validation.states).indexOf('error') < 0);
        let validQuestions = this.validateQuestions();

        return valid && validQuestions;
    }

    handleSubmit(event) {
        event.preventDefault();
        if (this.isValid()){
            let style = "<style>/*!\n" +
                " * Quill Editor v1.3.0\n" +
                " * https://quilljs.com/\n" +
                " * Copyright (c) 2014, Jason Chen\n" +
                " * Copyright (c) 2013, salesforce.com\n" +
                " */.ql-container.ql-disabled .ql-editor ul[data-checked]>li::before,.ql-editor ul[data-checked=false],.ql-editor ul[data-checked=true]{pointer-events:none}.ql-container{box-sizing:border-box;font-family:Helvetica,Arial,sans-serif;font-size:13px;height:100%;margin:0;position:relative}.ql-container.ql-disabled .ql-tooltip{visibility:hidden}.ql-clipboard{left:-100000px;height:1px;overflow-y:hidden;position:absolute;top:50%}.ql-clipboard p{margin:0;padding:0}.ql-editor{box-sizing:border-box;line-height:1.42;height:100%;outline:0;padding:12px 15px;tab-size:4;-moz-tab-size:4;text-align:left;white-space:pre-wrap;word-wrap:break-word}.ql-editor>*{cursor:text}.ql-editor h1,.ql-editor h2,.ql-editor h3,.ql-editor h4,.ql-editor h5,.ql-editor h6,.ql-editor ol,.ql-editor p,.ql-editor pre,.ql-editor ul{margin:0;padding:0;counter-reset:list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9}.ql-editor blockquote{border-left:4px solid #ccc;margin-bottom:5px;margin-top:5px;padding-left:16px}.ql-editor ol,.ql-editor ol li:not(.ql-direction-rtl),.ql-editor ul,.ql-editor ul li:not(.ql-direction-rtl){padding-left:1.5em}.ql-editor ol>li,.ql-editor ul>li{list-style-type:none}.ql-editor ul>li::before{content:'\\2022'}.ql-editor ul[data-checked=false]>li *,.ql-editor ul[data-checked=true]>li *{pointer-events:all}.ql-editor ul[data-checked=false]>li::before,.ql-editor ul[data-checked=true]>li::before{color:#777;cursor:pointer;pointer-events:all}.ql-editor ul[data-checked=true]>li::before{content:'\\2611'}.ql-editor ul[data-checked=false]>li::before{content:'\\2610'}.ql-editor li::before{display:inline-block;white-space:nowrap;width:1.2em}.ql-editor li:not(.ql-direction-rtl)::before{margin-left:-1.5em;margin-right:.3em;text-align:right}.ql-editor li.ql-direction-rtl::before{margin-left:.3em;margin-right:-1.5em}.ql-editor ol li.ql-direction-rtl,.ql-editor ul li.ql-direction-rtl{padding-right:1.5em}.ql-editor ol li{counter-reset:list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;counter-increment:list-0}.ql-editor ol li:before{content:counter(list-0,decimal) '. '}.ql-editor ol li.ql-indent-1{counter-increment:list-1;counter-reset:list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9}.ql-editor ol li.ql-indent-1:before{content:counter(list-1,lower-alpha) '. '}.ql-editor ol li.ql-indent-2{counter-increment:list-2;counter-reset:list-3 list-4 list-5 list-6 list-7 list-8 list-9}.ql-editor ol li.ql-indent-2:before{content:counter(list-2,lower-roman) '. '}.ql-editor ol li.ql-indent-3{counter-increment:list-3;counter-reset:list-4 list-5 list-6 list-7 list-8 list-9}.ql-editor ol li.ql-indent-3:before{content:counter(list-3,decimal) '. '}.ql-editor ol li.ql-indent-4{counter-increment:list-4;counter-reset:list-5 list-6 list-7 list-8 list-9}.ql-editor ol li.ql-indent-4:before{content:counter(list-4,lower-alpha) '. '}.ql-editor ol li.ql-indent-5{counter-increment:list-5;counter-reset:list-6 list-7 list-8 list-9}.ql-editor ol li.ql-indent-5:before{content:counter(list-5,lower-roman) '. '}.ql-editor ol li.ql-indent-6{counter-increment:list-6;counter-reset:list-7 list-8 list-9}.ql-editor ol li.ql-indent-6:before{content:counter(list-6,decimal) '. '}.ql-editor ol li.ql-indent-7{counter-increment:list-7;counter-reset:list-8 list-9}.ql-editor ol li.ql-indent-7:before{content:counter(list-7,lower-alpha) '. '}.ql-editor ol li.ql-indent-8{counter-increment:list-8;counter-reset:list-9}.ql-editor ol li.ql-indent-8:before{content:counter(list-8,lower-roman) '. '}.ql-editor ol li.ql-indent-9{counter-increment:list-9}.ql-editor ol li.ql-indent-9:before{content:counter(list-9,decimal) '. '}.ql-editor .ql-indent-1:not(.ql-direction-rtl){padding-left:3em}.ql-editor li.ql-indent-1:not(.ql-direction-rtl){padding-left:4.5em}.ql-editor .ql-indent-1.ql-direction-rtl.ql-align-right{padding-right:3em}.ql-editor li.ql-indent-1.ql-direction-rtl.ql-align-right{padding-right:4.5em}.ql-editor .ql-indent-2:not(.ql-direction-rtl){padding-left:6em}.ql-editor li.ql-indent-2:not(.ql-direction-rtl){padding-left:7.5em}.ql-editor .ql-indent-2.ql-direction-rtl.ql-align-right{padding-right:6em}.ql-editor li.ql-indent-2.ql-direction-rtl.ql-align-right{padding-right:7.5em}.ql-editor .ql-indent-3:not(.ql-direction-rtl){padding-left:9em}.ql-editor li.ql-indent-3:not(.ql-direction-rtl){padding-left:10.5em}.ql-editor .ql-indent-3.ql-direction-rtl.ql-align-right{padding-right:9em}.ql-editor li.ql-indent-3.ql-direction-rtl.ql-align-right{padding-right:10.5em}.ql-editor .ql-indent-4:not(.ql-direction-rtl){padding-left:12em}.ql-editor li.ql-indent-4:not(.ql-direction-rtl){padding-left:13.5em}.ql-editor .ql-indent-4.ql-direction-rtl.ql-align-right{padding-right:12em}.ql-editor li.ql-indent-4.ql-direction-rtl.ql-align-right{padding-right:13.5em}.ql-editor .ql-indent-5:not(.ql-direction-rtl){padding-left:15em}.ql-editor li.ql-indent-5:not(.ql-direction-rtl){padding-left:16.5em}.ql-editor .ql-indent-5.ql-direction-rtl.ql-align-right{padding-right:15em}.ql-editor li.ql-indent-5.ql-direction-rtl.ql-align-right{padding-right:16.5em}.ql-editor .ql-indent-6:not(.ql-direction-rtl){padding-left:18em}.ql-editor li.ql-indent-6:not(.ql-direction-rtl){padding-left:19.5em}.ql-editor .ql-indent-6.ql-direction-rtl.ql-align-right{padding-right:18em}.ql-editor li.ql-indent-6.ql-direction-rtl.ql-align-right{padding-right:19.5em}.ql-editor .ql-indent-7:not(.ql-direction-rtl){padding-left:21em}.ql-editor li.ql-indent-7:not(.ql-direction-rtl){padding-left:22.5em}.ql-editor .ql-indent-7.ql-direction-rtl.ql-align-right{padding-right:21em}.ql-editor li.ql-indent-7.ql-direction-rtl.ql-align-right{padding-right:22.5em}.ql-editor .ql-indent-8:not(.ql-direction-rtl){padding-left:24em}.ql-editor li.ql-indent-8:not(.ql-direction-rtl){padding-left:25.5em}.ql-editor .ql-indent-8.ql-direction-rtl.ql-align-right{padding-right:24em}.ql-editor li.ql-indent-8.ql-direction-rtl.ql-align-right{padding-right:25.5em}.ql-editor .ql-indent-9:not(.ql-direction-rtl){padding-left:27em}.ql-editor li.ql-indent-9:not(.ql-direction-rtl){padding-left:28.5em}.ql-editor .ql-indent-9.ql-direction-rtl.ql-align-right{padding-right:27em}.ql-editor li.ql-indent-9.ql-direction-rtl.ql-align-right{padding-right:28.5em}.ql-editor .ql-video{display:block;max-width:100%}.ql-editor .ql-video.ql-align-center{margin:0 auto}.ql-editor .ql-video.ql-align-right{margin:0 0 0 auto}.ql-editor .ql-bg-black{background-color:#000}.ql-editor .ql-bg-red{background-color:#e60000}.ql-editor .ql-bg-orange{background-color:#f90}.ql-editor .ql-bg-yellow{background-color:#ff0}.ql-editor .ql-bg-green{background-color:#008a00}.ql-editor .ql-bg-blue{background-color:#06c}.ql-editor .ql-bg-purple{background-color:#93f}.ql-editor .ql-color-white{color:#fff}.ql-editor .ql-color-red{color:#e60000}.ql-editor .ql-color-orange{color:#f90}.ql-editor .ql-color-yellow{color:#ff0}.ql-editor .ql-color-green{color:#008a00}.ql-editor .ql-color-blue{color:#06c}.ql-editor .ql-color-purple{color:#93f}.ql-editor .ql-font-serif{font-family:Georgia,Times New Roman,serif}.ql-editor .ql-font-monospace{font-family:Monaco,Courier New,monospace}.ql-editor .ql-size-small{font-size:.75em}.ql-editor .ql-size-large{font-size:1.5em}.ql-editor .ql-size-huge{font-size:2.5em}.ql-editor .ql-direction-rtl{direction:rtl;text-align:inherit}.ql-editor .ql-align-center{text-align:center}.ql-editor .ql-align-justify{text-align:justify}.ql-editor .ql-align-right{text-align:right}.ql-editor .ql-embed-selected{border:1px solid #777;user-select:none}.ql-editor.ql-blank::before{color:rgba(0,0,0,.6);content:attr(data-placeholder);font-style:italic;pointer-events:none;position:absolute}</style>";
            this.setState({inProcess: true});
            this.props.action({
                ...this.state.values,
                materialText: style+"<div class='ql-editor'>"+this.state.values.materialText+"</div>"
            });
        }
    }

    handleClose() {
        this.props.history.push('/educationMaterials');
    }
    /* /Form functions */


    render() {
        let {messages, states} = this.state.validation;
        let values = this.state.values;
        let questions = values.questions;
        let title = this.props.data ? this.props.title + " č. " + this.state.values.name : this.props.title;

        const tooltipRemoveAnswer = (
            <Tooltip id="tooltip-remove">Odebrat odpověď</Tooltip>
        );

        const modules = {
            toolbar: [
                [{ 'header': [1, 2, false] }],
                [{'align': []}],
                ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                [{'list': 'ordered'}, {'list': 'bullet'}, {'indent': '-1'}, {'indent': '+1'}],
                ['link', 'image'],
                ['clean']
            ],
        };

        const formats = [
            'header',
            'align',
            'bold', 'italic', 'underline', 'strike', 'blockquote',
            'list', 'bullet', 'indent',
            'link', 'image'
        ];

        return (
            <div className="x-panel">
                <div className="x-title">
                    <h2>{title}</h2>
                    <div className="clearfix"/>
                </div>
                <div className="x-content">
                    {
                        this.state.loading ? <Loading/> :
                            <Form onSubmit={this.handleSubmit}>
                                <div>
                                    <h4>Základní údaje</h4>
                                    <FormGroup controlId="text" validationState={states.name}>
                                        <ControlLabel>Název vzdělávacího materiálu <span
                                            className="required">*</span></ControlLabel>
                                        <FormControl type="text" value={values.name}
                                                     onChange={this.handleChangeName}
                                                     placeholder="Zadejte název vzdělávacího materiálu"
                                        />
                                        <FormControl.Feedback/>
                                        <HelpBlock>{messages.name}</HelpBlock>
                                    </FormGroup>
                                    <FormGroup controlId="shortText" validationState={states.shortText}>
                                        <ControlLabel>Krátký popis vzdělávacího materiálu <span
                                            className="required">*</span></ControlLabel>
                                        <FormControl
                                            componentClass="textarea" value={values.shortText}
                                            onChange={this.handleChangeShortText}
                                            placeholder="Zadejte krátký popis vzdělávacího materiálu"
                                        />
                                        <FormControl.Feedback/>
                                        <HelpBlock>{messages.shortText}</HelpBlock>
                                    </FormGroup>
                                    <FormGroup controlId="text" validationState={states.materialText}>
                                        <ControlLabel>Obsah vzdělávacího materiálu <span
                                            className="required">*</span></ControlLabel>
                                        <ReactQuill value={values.materialText}
                                                    modules={modules} formats={formats}
                                                    placeholder="Zadejte obsah vzdělávacího materiálu"
                                                    onChange={this.handleChangeText} />
                                        <HelpBlock>{messages.materialText}</HelpBlock>
                                    </FormGroup>
                                </div>
                                <div className="clearfix"/>
                                <div className="ln-solid"/>
                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <h4>Otázky</h4>
                                    <Accordion>
                                        {
                                            [...questions].map((question, questionIndex) => {
                                                let heading = question.name ? "Otázka č. " + question.name : "Nová otázka";
                                                let questionStates = this.state.validation.states.questions[questionIndex];
                                                let questionMessages = this.state.validation.messages.questions[questionIndex];
                                                let answers = question.answers;
                                                return (
                                                    <div key={questionIndex} className="row">
                                                        <div className="col-lg-11">
                                                            <CollapsiblePanel heading={heading}>
                                                                <div className="col-lg-5">
                                                                    <FormGroup controlId="text"
                                                                               validationState={questionStates.text}>
                                                                        <ControlLabel>Znění <span
                                                                            className="required">*</span></ControlLabel>
                                                                        <FormControl componentClass="textarea"
                                                                                     value={question.text}
                                                                                     // disabled={question.used}
                                                                                     onChange={(event) => this.handleChangeQuestionText(event, questionIndex)}
                                                                                     placeholder="Zadejte znění otázky"
                                                                        />
                                                                        <FormControl.Feedback/>
                                                                        <HelpBlock>{questionMessages.text}</HelpBlock>
                                                                    </FormGroup>
                                                                    <FormGroup controlId="explanation"
                                                                               validationState={questionStates.explanation}>
                                                                        <ControlLabel>Vysvětlení <span
                                                                            className="required">*</span></ControlLabel>
                                                                        <FormControl componentClass="textarea"
                                                                                     value={question.explanation}
                                                                                     // disabled={question.used}
                                                                                     onChange={(event) => this.handleChangeQuestionExplanation(event, questionIndex)}
                                                                                     placeholder="Zadejte vysvětlení otázky"
                                                                        />
                                                                        <FormControl.Feedback/>
                                                                        <HelpBlock>{questionMessages.explanation}</HelpBlock>
                                                                    </FormGroup>
                                                                </div>
                                                                <div className="col-lg-offset-1 col-lg-5">
                                                                    <Form componentClass="fieldset" horizontal>
                                                                        <h2>Odpovědi</h2>
                                                                        <table className="table">
                                                                            <thead>
                                                                            <tr>
                                                                                <th>Odpověď <span
                                                                                    className="required">*</span></th>
                                                                                <th>Správná odpověď</th>
                                                                                <th/>
                                                                            </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                            {
                                                                                [...answers].map((answer, answerIndex) => {
                                                                                        let answerStates = questionStates.answers[answerIndex];
                                                                                        let answerMessages = questionMessages.answers[answerIndex];
                                                                                        return (
                                                                                            <tr key={answerIndex}>
                                                                                                <td>
                                                                                                    <FormGroup
                                                                                                        controlId="answerText"
                                                                                                        validationState={answerStates.text}>
                                                                                                        <FormControl
                                                                                                            type="text"
                                                                                                            value={answer.text}
                                                                                                            //disabled={question.used}
                                                                                                            onChange={(event) => this.handleChangeAnswerText(event, questionIndex, answerIndex)}
                                                                                                            placeholder="Zadejte znění odpovědi"
                                                                                                        />
                                                                                                        <FormControl.Feedback/>
                                                                                                        <HelpBlock>{answerMessages.text}</HelpBlock>
                                                                                                    </FormGroup>
                                                                                                </td>
                                                                                                <td>
                                                                                                    <Radio
                                                                                                        checked={answer.correctness}
                                                                                                        //disabled={question.used}
                                                                                                        onChange={(event) => this.handleChangeAnswerCorrectness(event, questionIndex, answerIndex)}/>
                                                                                                </td>
                                                                                                <td>
                                                                                                    {
                                                                                                        //!question.used &&
                                                                                                        <OverlayTrigger
                                                                                                            placement="top"
                                                                                                            overlay={tooltipRemoveAnswer}>
                                                                                                            <FontAwesome
                                                                                                                name="trash"
                                                                                                                size="2x"
                                                                                                                onClick={() => this.handleRemoveAnswer(questionIndex, answerIndex)}
                                                                                                                className="cursor-p"
                                                                                                            />
                                                                                                        </OverlayTrigger>
                                                                                                    }
                                                                                                </td>
                                                                                            </tr>
                                                                                        );
                                                                                    }
                                                                                )}
                                                                            </tbody>
                                                                        </table>
                                                                        <Button type="button"
                                                                                className="btn btn-success"
                                                                                onClick={() => this.handleAddAnswer(questionIndex)}>
                                                                            Přidat odpověď
                                                                        </Button>
                                                                    </Form>
                                                                </div>
                                                            </CollapsiblePanel>
                                                        </div>
                                                    </div>
                                                );
                                            })
                                        }
                                    </Accordion>
                                    <FormGroup validationState={this.state.validation.states.questionMessage}>
                                        <HelpBlock>{this.state.validation.messages.questionMessage}</HelpBlock>
                                    </FormGroup>
                                </div>
                                <div className="clearfix"/>
                                <div className="ln-solid"/>
                                <FormGroup>
                                    <div className="col-md-4 col-sm-4 col-xs-12 col-md-offset-4">
                                        <Button className="btn-primary" type="button"
                                                onClick={this.handleClose}>Zpět</Button>
                                        <Button type="submit" disabled={this.state.inProcess}
                                                className="btn btn-success">{this.props.button}</Button>
                                        {this.state.inProcess && <Loading/>}
                                    </div>
                                </FormGroup>
                            </Form>
                    }
                </div>
            </div>
        );
    }
}

export default withRouter(EducationMaterialForm);



/** WEBPACK FOOTER **
 ** ./src/containers/EducationMaterials/EducationMaterialForm.js
 **/